/*
 * サブシステム名：
 * 機能名：定型コース一覧
 * 表示項目カスタマイズ(滋賀自工)
 */
import D2MSTD0450 from '@/views/MST/D2MSTD0450.js'

export default {
  extends: D2MSTD0450,
  name: 'MstTeikeiCorceListCustomForSGJ',
  data: () => ({
    custoMizeHeaders: [
      { text: '編集', value: 'actions', sortable: false, width: '20px' },
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '得意先名称', value: 'tokuisakiDisp' },
      { text: '担当営業所', value: 'tantoEigyoshoDisp' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiNm' },
      { text: '商品備考', value: 'hinmeiBiko' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '作業単価', value: 'warimashiKyoriTanka', align: 'end' },
      { text: '作業数量', value: 'warimashiTaishoKyori', align: 'end' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速代・交通費', value: 'hiwayPrice', align: 'end' },
      { text: 'その他運賃', value: 'unchinHokaKingaku', align: 'end' },
      { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
      { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
      { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
      { text: '非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '不課税', value: 'tatekaekinHikazei', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
      { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' }
    ]
  }),
  computed: {
  },
  methods: {
  }
}
